import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const FONT_STYLE = `
    .events-hero-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 10;
    }
`;
const EventsHero = () => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{FONT_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      scale: 1.1,
      opacity: 0
    };
    t2 = {
      scale: 1,
      opacity: 0.25
    };
    t3 = {
      duration: 2,
      ease: "easeOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.div initial={t1} animate={t2} transition={t3} className="absolute inset-0 z-0"><img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2000&auto=format&fit=crop" alt="Conference auditorium prepared for a Girmitiya Council gathering" className="w-full h-full object-cover grayscale-[40%] sepia-[30%]" /><div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E] via-[#0F1C2E]/50 to-transparent" /></motion.div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      y: 20
    };
    t6 = {
      opacity: 1,
      y: 0
    };
    t7 = {
      duration: 1,
      delay: 0.2
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <motion.div initial={t5} animate={t6} transition={t7} className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6 md:mb-8"><div className="w-8 sm:w-12 h-px bg-[#DF6D2A]" /><span className="font-body text-[11px] tracking-[0.3em] uppercase text-[#C9A84C]">Council Calendar</span><div className="w-8 sm:w-12 h-px bg-[#DF6D2A]" /></motion.div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      y: 30
    };
    t10 = {
      opacity: 1,
      y: 0
    };
    t11 = {
      duration: 1,
      delay: 0.4
    };
    $[9] = t10;
    $[10] = t11;
    $[11] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <br />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <motion.h1 initial={t9} animate={t10} transition={t11} className="font-display text-[36px] sm:text-[52px] md:text-[72px] lg:text-[90px] xl:text-[120px] leading-[0.95] text-[#F4EFE6] tracking-[-0.02em] uppercase max-w-[1000px]">{"Gatherings & "}{t12} <em className="text-[#DF6D2A] italic">Exhibitions</em></motion.h1>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <>{t0}<section className="relative min-h-[420px] h-[65vh] sm:h-[70vh] md:h-[80vh] max-h-[800px] bg-[#0F1C2E] overflow-hidden flex flex-col justify-center events-hero-grain border-b border-[#C9A84C]/20">{t4}<div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 md:px-12 relative z-20 flex flex-col items-center text-center mt-10 sm:mt-14 md:mt-20">{t8}{t13}<motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1,
            delay: 0.8
          }} className="font-body text-[14px] sm:text-[16px] md:text-[18px] text-white/60 font-light mt-6 sm:mt-8 md:mt-12 max-w-[600px] leading-[1.7] sm:leading-[1.8]">Join the global diaspora in our mission to preserve, educate, and celebrate the Girmitiya heritage through symposiums, cultural galas, and archival displays.</motion.p></div></section></>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  return t14;
};
export default EventsHero;